<script>
import CommonConstants from '@/common/Constants';
import Utils from '@/common/Utils';

import ResponsiveButton from '@/components/generic/ResponsiveButton.vue';
import DemurrageStatisticsGraph from '@/components/demurrage/DemurrageStatisticsGraph.vue';
import DemurragePivotGraph from '@/components/demurrage/DemurragePivotGraph.vue';
import Service from '@/services/demurrage';
import GenericCustomMultiSelect from '@/components/generic/GenericCustomMultiSelect.vue';
import { FilterMatchMode } from 'primevue/api';
export default {
    components: { ResponsiveButton, DemurrageStatisticsGraph, DemurragePivotGraph, GenericCustomMultiSelect },
    data() {
        return {
            referenceDate: new Date(),
            showReasons: false,
            showPreviousYears: false,
            recapLoading: false,
            recapData: [],
            recapReasons: [],
            plantLoading: false,
            plantData: [],
            chargeDischargeLoading: false,
            chargeDischargeData: [],
            graphs: [],
            recapColumns: [
                {
                    columnName: 'counterpartyOriginalRequest',
                    columnLabel: 'DemurrageStatistics.counterpartyOriginalRequest'
                },
                {
                    columnName: 'counterpartyUpdatedRequest',
                    columnLabel: 'DemurrageStatistics.counterpartyUpdatedRequest'
                },
                {
                    columnName: 'grossMonthlyAverageTimeOnDemurrage',
                    columnLabel: 'DemurrageStatistics.grossMonthlyAverageTimeOnDemurrage'
                },
                {
                    columnName: 'grossMonthlyDemurrageRatioHrsTon',
                    columnLabel: 'DemurrageStatistics.grossMonthlyDemurrageRatioHrsTon'
                },
                {
                    columnName: 'grossMonthlyDemurrageRatioTotalTon',
                    columnLabel: 'DemurrageStatistics.grossMonthlyDemurrageRatioTotalTon'
                },
                {
                    columnName: 'grossQuantity',
                    columnLabel: 'DemurrageStatistics.grossQuantity'
                },
                {
                    columnName: 'grossTimeOnDemurrage',
                    columnLabel: 'DemurrageStatistics.grossTimeOnDemurrage'
                },
                {
                    columnName: 'grossTotalDemurrage',
                    columnLabel: 'DemurrageStatistics.grossTotalDemurrage'
                },
                {
                    columnName: 'grossYearlyAverageTimeOnDemurrage',
                    columnLabel: 'DemurrageStatistics.grossYearlyAverageTimeOnDemurrage'
                },
                {
                    columnName: 'grossYearlyDemurrageRatioHrsTon',
                    columnLabel: 'DemurrageStatistics.grossYearlyDemurrageRatioHrsTon'
                },
                {
                    columnName: 'grossYearlyDemurrageRatioTotalTon',
                    columnLabel: 'DemurrageStatistics.grossYearlyDemurrageRatioTotalTon'
                },
                {
                    columnName: 'monthlyAverageDemurrageRate',
                    columnLabel: 'DemurrageStatistics.monthlyAverageDemurrageRate'
                },
                {
                    columnName: 'netMonthlyAverageTimeOnDemurrage',
                    columnLabel: 'DemurrageStatistics.netMonthlyAverageTimeOnDemurrage'
                },
                {
                    columnName: 'netMonthlyDemurrageRatioHrsTon',
                    columnLabel: 'DemurrageStatistics.netMonthlyDemurrageRatioHrsTon'
                },
                {
                    columnName: 'netMonthlyDemurrageRatioTotalTon',
                    columnLabel: 'DemurrageStatistics.netMonthlyDemurrageRatioTotalTon'
                },
                {
                    columnName: 'netQuantity',
                    columnLabel: 'DemurrageStatistics.netQuantity'
                },
                {
                    columnName: 'netTimeOnDemurrage',
                    columnLabel: 'DemurrageStatistics.netTimeOnDemurrage'
                },
                {
                    columnName: 'netTotalDemurrage',
                    columnLabel: 'DemurrageStatistics.netTotalDemurrage'
                },
                {
                    columnName: 'netYearlyAverageTimeOnDemurrage',
                    columnLabel: 'DemurrageStatistics.netYearlyAverageTimeOnDemurrage'
                },
                {
                    columnName: 'netYearlyDemurrageRatioHrsTon',
                    columnLabel: 'DemurrageStatistics.netYearlyDemurrageRatioHrsTon'
                },
                {
                    columnName: 'netYearlyDemurrageRatioTotalTon',
                    columnLabel: 'DemurrageStatistics.netYearlyDemurrageRatioTotalTon'
                },
                {
                    columnName: 'yearlyAverageDemurrageRate',
                    columnLabel: 'DemurrageStatistics.yearlyAverageDemurrageRate'
                }
            ],
            pivotData: [],
            pivotLoading: false,
            pivotFilters: {
                chargeDischarge: [],
                plant: [],
                month: [],
                product: [],
            },
            progressiveData: [],
            progressiveDataLoading: false,
            newGraphs: [],
            editingRowsActVsBudget: [],
            actVsBudgetData: [],
            actVsBudgetLoading: false,
            actVsBudgetColumns: [
                {
                    columnType: 'bar',
                    columnName: 'totalDemurrageGross',
                    columnLabel: 'DemurrageStatistics.grossTotalDemurrage'
                },
                // {
                //     columnType: 'bar',
                //     columnName: 'totalDemurrageNet',
                //     columnLabel: 'DemurrageStatistics.netTotalDemurrage'
                // },
                {
                    columnType: 'bar',
                    columnName: 'budget',
                    columnLabel: 'DemurrageStatistics.budget'
                },
                {
                    columnType: 'bar',
                    columnName: 'estimatedVsBudget',
                    columnLabel: 'DemurrageStatistics.estimatedVsBudget'
                },
                {
                    columnType: 'bar',
                    columnName: 'previousYearGrossDemurrage',
                    columnLabel: 'Previous Year Gross Demurrage'
                },
                {
                    columnType: 'bar',
                    columnName: 'previousYearDelta',
                    columnLabel: 'Gross Demurrage - Actual previous year'
                }
            ],
            lastYears: [],
            lastYearsRecapData: {},
            selectedMonths: [],
            recapFilters: { referenceDate: { value: null, matchMode: FilterMatchMode.CONTAINS } }
        };
    },
    computed: {
        headerDeltaActVsBudget(){
            let h = 'Estimated ' + '- Actual previous year'
            return h
        },
        months() {
            let m = []
            if (this.referenceDate) {
                for (let i = 0; i < 12; i++) {
                    m.push(
                        {
                            name: this.$t('monthNames.' + i),
                            value: new Date(Date.UTC(this.referenceDate.getFullYear(), i, 1)).toISOString().slice(0, -5)
                        }
                    )
                }
            }
            return m;
        },
        monthsNumber() {
            let m = []
            if (this.referenceDate) {
                for (let i = 0; i < 12; i++) {
                    m.push(
                        {
                            name: this.$t('monthNames.' + i),
                            value: i +1
                        }
                    )
                }
            }
            return m;
        },
        constants() {
            return CommonConstants;
        },
        utils() {
            return Utils;
        },
        uiPermissions() {
            return this.$store.getters['security/uiPermissions'];
        },
        reasonColumns() {
            let reasonColumns = [];
            this.recapReasons.forEach(r => {
                reasonColumns.push({
                    key: r,
                    value: 'totalDemurrage',
                    label: r,
                    isPercent: false
                }, {
                    key: r,
                    value: 'totalDemurragePercent',
                    label: r + ' %',
                    isPercent: true
                });
            });
            return reasonColumns;
        },
        demurrageRatioTotalTonData() {
            const documentStyle = getComputedStyle(document.documentElement);

            let labels = this.recapData.map(i => Utils.formatDate(Utils.dateToCurrentTimeZone((i.referenceDate))));
            return {
                labels: labels,
                datasets: [
                    {
                        label: this.$t('DemurrageStatistics.grossMonthlyDemurrageRatioTotalTon'),
                        data: this.recapData.map(i => i.grossMonthlyDemurrageRatioTotalTon),
                        backgroundColor: ['rgba(6, 182, 212, 0.2)'],
                        borderColor: ['rgb(6, 182, 212)'],
                        borderWidth: 1
                    },
                    {
                        label: this.$t('DemurrageStatistics.netMonthlyDemurrageRatioTotalTon'),
                        data: this.recapData.map(i => i.netMonthlyDemurrageRatioTotalTon),
                        backgroundColor: ['rgba(249, 115, 22, 0.2)'],
                        borderColor: ['rgb(249, 115, 22)'],
                        borderWidth: 1
                    },
                    {
                        type: 'line',
                        label: this.$t('DemurrageStatistics.grossYearlyDemurrageRatioTotalTon'),
                        borderColor: documentStyle.getPropertyValue('--cyan-500'),
                        borderWidth: 2,
                        fill: false,
                        tension: 0.4,
                        data: this.recapData.map(i => i.grossYearlyDemurrageRatioTotalTon)
                    },
                    {
                        type: 'line',
                        label: this.$t('DemurrageStatistics.netYearlyDemurrageRatioTotalTon'),
                        borderColor: documentStyle.getPropertyValue('--orange-500'),
                        borderWidth: 2,
                        fill: false,
                        tension: 0.4,
                        data: this.recapData.map(i => i.netYearlyDemurrageRatioTotalTon)
                    }
                ]
            }
        },
        demurrageRatioTotalTonChartOptions() {
            const documentStyle = getComputedStyle(document.documentElement);
            const textColor = documentStyle.getPropertyValue('--text-color');
            const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
            const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

            return {
                plugins: {
                    legend: {
                        labels: {
                            color: textColor
                        }
                    }
                },
                scales: {
                    x: {
                        beginAtZero: true,
                        ticks: {
                            color: textColorSecondary
                        },
                        grid: {
                            color: surfaceBorder
                        }
                    },
                    y: {
                        beginAtZero: true,
                        ticks: {
                            color: textColorSecondary
                        },
                        grid: {
                            color: surfaceBorder
                        }
                    }
                }
            };
        },
        reasonColumnShow() {
            return this.showReasons ? this.reasonColumns : []
        },
        previousYearsColumnShow() {
            return this.showPreviousYears ? this.lastYears : []
        },
        pivotGridData() {
            let data = [];
            for (let key in this.pivotData) {
                data.push({ key, ...this.pivotData[key] })
            }
            return data;
        },
        pivotGridDataFiltered() {
            let data = [];
            for (let key in this.pivotData) {
                if(key != 'TOTAL'){
                    data.push({ key, ...this.pivotData[key] })
                }
            }
            return data;
        },
        pivotMonths() {
            let data = [];

            if (this.referenceDate) {
                let y = this.referenceDate.getFullYear();

                for (let i = 0; i < 12; i++) {
                    let d = new Date(y, i, 1);

                    data.push({
                        name: d.toLocaleString(localStorage.getItem('language') ? localStorage.getItem('language').toLocaleUpperCase() : 'en', { month: 'long' }),
                        value: Utils.formatDateForAPI(d),
                    })
                }
            }

            return data;
        },
        availableYears() {
            let list = []
            if (this.referenceDate) {
                let current = this.referenceDate.getFullYear();
                if (current > 2023) {
                    let y = current - 1;
                    while (y >= 2023) {
                        list.push(y);
                        y--;
                    }
                }
            }
            return list;
        }
    },
    created() {
        this.$store.dispatch('security/setNavbarTitle', this.$t('DemurrageStatistics.page_title'));
    },
    methods: {
        loadData() {
            this.loadRecap();
            this.loadPlant();
            this.loadChargeDischarge();
            this.loadPivot();
            this.loadGraphs();
            this.loadProgressive();
            this.loadActVsBudget();
        },
        loadRecap() {
            this.recapData = [];
            this.recapReasons = [];
            this.recapLoading = true;

            let lastYearString = this.lastYears ? this.lastYears.toLocaleString() : '';
            let monthsString = this.selectedMonths ? this.selectedMonths.toLocaleString() : '';

            let params = {
                referenceDate: Utils.formatDateForAPI(this.referenceDate),
                showReasons: true,
                lastYears: lastYearString,
                months: monthsString
            }
            Service.getRecap(params, response => {
                this.recapLoading = false;
                if (response.success) {
                    this.recapData = response.data.data;
                    this.recapData.push(response.data.totalData);
                    this.recapReasons = response.data.reasons;
                }
            })
        },
        loadPlant() {
            let monthsString = this.selectedMonths ? this.selectedMonths.toLocaleString() : '';
            this.plantData = [];
            this.plantLoading = true;
            let params = {
                referenceDate: Utils.formatDateForAPI(this.referenceDate),
                months: monthsString
            }
            Service.getPlantStatistics(params, response => {
                this.plantLoading = false;
                if (response.success) {
                    this.plantData = response.data;
                }
            })
        },
        loadChargeDischarge() {
            let monthsString = this.selectedMonths ? this.selectedMonths.toLocaleString() : '';
            this.chargeDischargeData = [];
            this.chargeDischargeLoading = true;
            let params = {
                referenceDate: Utils.formatDateForAPI(this.referenceDate),
                months: monthsString
            }
            Service.getChargeDischargeStatistics(params, response => {
                this.chargeDischargeLoading = false;
                if (response.success) {
                    this.chargeDischargeData = response.data;
                }
            })

        },
        loadPivot() {
            let body = {
                referenceDate: Utils.formatDateForAPI(this.referenceDate),
                months: this.pivotFilters.month,
                plants: this.pivotFilters.plant,
                chargeDischarge: this.pivotFilters.chargeDischarge,
                products: this.pivotFilters.product,
            };
            this.pivotData = [];
            this.pivotLoading = true;
            Service.getPivot(body, response => {
                this.pivotLoading = false;
                if (response.success) {
                    this.pivotData = response.data;
                }
            })
        },
        loadGraphs() {
            this.graphs = [];
            this.newGraphs = [];
            Service.getGraphs(response => {
                if (response.success) {
                    this.graphs = response.data;
                }
            });
        },
        addNewGraph() {
            this.newGraphs.push({})
        },
        loadProgressive() {
            let monthsString = this.selectedMonths ? this.selectedMonths.toLocaleString() : '';
            this.progressiveData = [];
            this.progressiveDataLoading = true;
            let params = {
                referenceDate: Utils.formatDateForAPI(this.referenceDate),
                months: monthsString
            }
            Service.getProgressive(params, response => {
                this.progressiveDataLoading = false;
                if (response.success) {
                    this.progressiveData = response.data;
                }
            })
        },
        loadActVsBudget() {
            let monthsString = this.selectedMonths ? this.selectedMonths.toLocaleString() : '';
            this.actVsBudgetData = [];
            this.actVsBudgetLoading = true;
            let params = {
                referenceDate: Utils.formatDateForAPI(this.referenceDate),
                months: monthsString
            }
            Service.getActVsBudget(params, response => {
                this.actVsBudgetLoading = false;
                if (response.success) {
                    this.actVsBudgetData = response.data;
                }
            })
        },
        onRowEditActVsBudgetSave(event) {
            let { newData, index } = event;
            this.actVsBudgetData[index] = newData;
            if (this.actVsBudgetData[index].id != null) {
                Service.updateActVsBudget(this.actVsBudgetData[index], (response) => {
                    if (response.success) {
                        this.loadActVsBudget();
                        this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
                    } else {
                        this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                    }
                });
            } else {
                Service.createActVsBudget(this.actVsBudgetData[index], (response) => {
                    if (response.success) {
                        this.loadActVsBudget();
                        this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
                    } else {
                        this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                    }
                });
            }
        },
        exportExcel() {
            let lastYearString = this.lastYears ? this.lastYears.toLocaleString() : '';
            this.$store.dispatch('generic/setLoading', true);
            let fileNameWithExtension = this.referenceDate ? 'Statistics_Summary_' + this.referenceDate.getFullYear() + '.xlsx' : 'Statistics_Summary.xlsx';
            const params = {
                referenceDate: this.referenceDate,
                lastYears: lastYearString,
            };
            Service.exportStatisticsExcel(params, (response) => {
                this.$store.dispatch('generic/setLoading', false);
                if (response.success) {
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', fileNameWithExtension);
                    document.body.appendChild(fileLink);
                    fileLink.click();
                } else {
                    this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            });
        },
        onDateSelected() {
            this.lastYears = []
            this.selectedMonths = this.monthsNumber.map(x => x.value)
        },
        pivotTotal(column) {
            let total = 0;
            for (let i of this.pivotGridData) {
                total += i[column];
            }

            return total;
        },
        plantTotal(column) {
            let total = 0;
            for (let i of this.plantData) {
                total += i[column];
            }
            return total;
        },
        plantTotalPercent(plant) {
            let totalSouth = 0, totalNorth = 0, total = 0;

            for (let i of this.plantData) {
                totalSouth += i.southTotalDemurrage;
                totalNorth += i.northTotalDemurrage;
            }
            
            total = totalSouth + totalNorth;
            if(total != 0){
                if(plant == 'SOUTH'){
                    return (100*totalSouth)/total;
                }else if(plant == 'NORTH'){
                    return (100*totalNorth)/total;
                }
            }

            return 0;
        },
        chargeDischargeTotal(column) {
            let total = 0;
            for (let i of this.chargeDischargeData) {
                total += i[column];
            }
            return total;
        },
        chargeDischargeTotalPercent(type) {
            let totalCharge = 0, totalDischarge = 0, total = 0;

            for (let i of this.chargeDischargeData) {
                totalCharge += i.chargeTotalDemurrage;
                totalDischarge += i.dischargeTotalDemurrage;
            }
            
            total = totalCharge + totalDischarge;
            if(total != 0){
                if(type == 'CHARGE'){
                    return (100*totalCharge)/total;
                }else if(type == 'DISCHARGE'){
                    return (100*totalDischarge)/total;
                }
            }

            return 0;
        },
        actVsBudgeTotal(column) {
            let total = 0;
            for (let i of this.actVsBudgetData) {
                total += i[column];
            }
            return total;
        },
        isTotal(data) {
            return data.referenceDate == '0001-01-01T00:00:00'
        }
    }
};
</script>

<template>
    <main>
        <div class="m-4">
            <div class="grid">
                <div class="col-12 lg:col-2 field">
                    <label>{{ $t('DemurrageStatistics.year') }}</label>
                    <Calendar :class="{ 'p-inputtext-sm w-full': true }" placeholder="yyyy" view="year" dateFormat="yy"
                        :showTime="false" v-model="referenceDate" :showIcon="true" :showButtonBar="true"
                        @date-select="onDateSelected" :yearNavigator="true" />
                </div>
                <div class="col-12 lg:col-2 field">
                    <label>{{ $t('DemurrageStatistics.selectedMonths') }}</label>
                    <MultiSelect v-model="selectedMonths" :options="monthsNumber" optionLabel="name" optionValue="value" class="w-full" />
                </div>
                <div class="col-12 lg:col-2 field">
                    <label>{{ $t('DemurrageStatistics.previous_years') }}</label>
                    <MultiSelect v-model="lastYears" :options="availableYears" class="w-full" />
                </div>
                <div class="col-12 lg:col-3 field m-4">
                    <ResponsiveButton :label="$t('btn.search')" icon="pi pi-search" @click="loadData"
                        class="p-button p-button-sm m-3" />
                    <ResponsiveButton :label="$t('btn.download')" icon="pi pi-file-excel" @click="exportExcel"
                        class="p-button p-button-sm p-button-success m-3" />
                </div>
                <TabView class="col-12">
                    <TabPanel :header="$t('DemurrageStatistics.recap')">
                        <div class="grid">
                            <div class="col-12">
                                <div class="m-2">
                                    <Checkbox v-model="showReasons" inputId="showReasons" :binary="true" />
                                    <label for="showReasons" class="ml-2"> {{ $t('DemurrageStatistics.showReasons') }}
                                    </label>
                                </div>
                                <div class="m-2">
                                    <Checkbox v-model="showPreviousYears" inputId="showPreviousYears" :binary="true" />
                                    <label for="showPreviousYears" class="ml-2"> {{
                                        $t('DemurrageStatistics.showPreviousYears') }}
                                    </label>
                                </div>
                                <DataTable :value="recapData" showGridlines stripedRows :reorderableColumns="false" :loading="recapLoading"
                                    scrollable :responsiveLayout="'stack'" scrollHeight="flex">

                                    <Column field="referenceDate" :header="$t('DemurrageStatistics.referenceDate')"
                                        dataType="date" style="width: 150px;">
                                        <template #body="element">
                                            <span :class="{ 'bold-total': isTotal(element.data) }">
                                                {{ element.data.referenceDate != null && !isTotal(element.data) ?
                                                    $t('monthNames.' + new Date(element.data.referenceDate).getMonth())
                                                    :
                                                    null }}
                                            </span>
                                        </template>
                                    </Column>

                                    <Column v-for="reason in reasonColumnShow" :key="reason.label"
                                        :header="reason.label" style="width: 80px;">
                                        <template #body="{ data }">
                                            <span v-if="data.reasons && data.reasons[reason.key]" :class="{ 'bold-total': isTotal(data) }">
                                                {{ !reason.isPercent ? '$ ' : '' }} {{
                                                    utils.formatInteger(Math.round(data.reasons[reason.key][reason.value]))
                                                }}
                                                {{ reason.isPercent ? ' %' : '' }}
                                            </span>
                                        </template>
                                    </Column>

                                    <Column :header="$t('DemurrageStatistics.grossTotalDemurrage')"
                                        style="width: 150px;">
                                        <template #body="{ data }">
                                            <span :class="{ 'bold-total': isTotal(data) }">
                                                {{ data.grossTotalDemurrage ? '$ ' +
                                                    utils.formatInteger(Math.round(data.grossTotalDemurrage)) : '' }}
                                            </span>
                                        </template>
                                    </Column>
                                    <Column :header="$t('DemurrageStatistics.netTotalDemurrage')" style="width: 150px;">
                                        <template #body="{ data }">
                                            <span :class="{ 'bold-total': isTotal(data) }">
                                                {{ data.netTotalDemurrage ? '$ ' +
                                                    utils.formatInteger(Math.round(data.netTotalDemurrage)) : '' }}
                                            </span>
                                        </template>
                                    </Column>
                                    <Column :header="$t('DemurrageStatistics.counterpartyOriginalRequest')"
                                        style="width: 150px;">
                                        <template #body="{ data }">
                                            <span :class="{ 'bold-total': isTotal(data) }">
                                                {{ data.counterpartyOriginalRequest ? '$ ' +
                                                    utils.formatInteger(Math.round(data.counterpartyOriginalRequest)) : ''
                                                }}
                                            </span>
                                        </template>
                                    </Column>
                                    <Column :header="$t('DemurrageStatistics.counterpartyUpdatedRequest')"
                                        style="width: 150px;">
                                        <template #body="{ data }">
                                            <span :class="{ 'bold-total': isTotal(data) }">
                                                {{ data.counterpartyUpdatedRequest ? '$ ' +
                                                    utils.formatInteger(Math.round(data.counterpartyUpdatedRequest)) : '' }}
                                            </span>
                                        </template>
                                    </Column>
                                    <Column :header="$t('DemurrageStatistics.monthlyAverageDemurrageRate')"
                                        style="width: 150px;">
                                        <template #body="{ data }">
                                            <span :class="{ 'bold-total': isTotal(data) }">
                                                {{ data.monthlyAverageDemurrageRate ? '$ ' +
                                                    utils.formatInteger(Math.round(data.monthlyAverageDemurrageRate)) : ''
                                                }}
                                            </span>
                                        </template>
                                    </Column>
                                    <Column :header="year + ' ' + $t('DemurrageStatistics.monthlyAverageDemurrageRate')"
                                        v-for="year in previousYearsColumnShow"
                                        :key="'monthlyAverageDemurrageRate_' + year" style="width: 150px;">
                                        <template #body="{ data }">
                                            <span :class="{ 'bold-total': isTotal(data.lastYears[year]) }">
                                                {{ data.lastYears[year]?.monthlyAverageDemurrageRate ? '$ ' +
                                                    utils.formatInteger(Math.round(data.lastYears[year].monthlyAverageDemurrageRate))
                                                : '' }}
                                            </span>
                                        </template>
                                    </Column>
                                    <Column :header="$t('DemurrageStatistics.yearlyAverageDemurrageRate')"
                                        style="width: 150px;">
                                        <template #body="{ data }">
                                            <span :class="{'bold-total': isTotal(data)}">
                                            {{ data.yearlyAverageDemurrageRate ? '$ ' +
                                                utils.formatInteger(Math.round(data.yearlyAverageDemurrageRate)) : '' }}
                                                </span>
                                        </template>
                                    </Column>

                                    <Column :header="year + ' ' + $t('DemurrageStatistics.yearlyAverageDemurrageRate')"
                                        v-for="year in previousYearsColumnShow"
                                        :key="'yearlyAverageDemurrageRate' + year" style="width: 150px;">
                                        <template #body="{ data }">
                                            <span :class="{ 'bold-total': isTotal(data.lastYears[year]) }">
                                            {{ data.lastYears[year]?.yearlyAverageDemurrageRate ? '$ ' +
                                                utils.formatInteger(Math.round(data.lastYears[year].yearlyAverageDemurrageRate))
                                            : '' }}
                                            </span>
                                        </template>
                                    </Column>

                                    <Column :header="$t('DemurrageStatistics.grossMonthlyAverageTimeOnDemurrage')"
                                        style="width: 150px;">
                                        <template #body="{ data }">
                                            <span :class="{'bold-total': isTotal(data)}">
                                            {{ utils.formatDecimal(data.grossMonthlyAverageTimeOnDemurrage, 1) }}
                                            </span>
                                        </template>
                                    </Column>

                                    <Column
                                        :header="year + ' ' + $t('DemurrageStatistics.grossMonthlyAverageTimeOnDemurrage')"
                                        v-for="year in previousYearsColumnShow"
                                        :key="'grossMonthlyAverageTimeOnDemurrage' + year" style="width: 150px;">
                                        <template #body="{ data }">
                                            <span :class="{ 'bold-total': isTotal(data.lastYears[year]) }">
                                            {{
                                                utils.formatDecimal(data.lastYears[year]?.grossMonthlyAverageTimeOnDemurrage,
                                            1) }}
                                            </span>
                                        </template>
                                    </Column>


                                    <Column :header="$t('DemurrageStatistics.netMonthlyAverageTimeOnDemurrage')"
                                        style="width: 150px;">
                                        <template #body="{ data }">
                                            <span :class="{'bold-total': isTotal(data)}">
                                            {{ utils.formatDecimal(data.netMonthlyAverageTimeOnDemurrage, 1) }}
                                            </span>
                                        </template>
                                    </Column>

                                    <Column
                                        :header="year + ' ' + $t('DemurrageStatistics.netMonthlyAverageTimeOnDemurrage')"
                                        v-for="year in previousYearsColumnShow"
                                        :key="'netMonthlyAverageTimeOnDemurrage' + year" style="width: 150px;">
                                        <template #body="{ data }">
                                            <span :class="{'bold-total': isTotal(data.lastYears[year])}">
                                            {{
                                                utils.formatDecimal(data.lastYears[year]?.netMonthlyAverageTimeOnDemurrage,
                                            1) }}
                                            </span>
                                        </template>
                                    </Column>

                                    <Column :header="$t('DemurrageStatistics.grossYearlyAverageTimeOnDemurrage')"
                                        style="width: 150px;">
                                        <template #body="{ data }">
                                            <span :class="{'bold-total': isTotal(data)}">
                                            {{ utils.formatDecimal(data.grossYearlyAverageTimeOnDemurrage, 1) }}
                                            </span>
                                        </template>
                                    </Column>

                                    <Column
                                        :header="year + ' ' + $t('DemurrageStatistics.grossYearlyAverageTimeOnDemurrage')"
                                        v-for="year in previousYearsColumnShow"
                                        :key="'grossYearlyAverageTimeOnDemurrage' + year" style="width: 150px;">
                                        <template #body="{ data }">
                                            <span :class="{'bold-total': isTotal(data.lastYears[year])}">
                                            {{
                                                utils.formatDecimal(data.lastYears[year]?.grossYearlyAverageTimeOnDemurrage,
                                            1) }}
                                            </span>
                                        </template>
                                    </Column>

                                    <Column :header="$t('DemurrageStatistics.netYearlyAverageTimeOnDemurrage')"
                                        style="width: 150px;">
                                        <template #body="{ data }">
                                            <span :class="{'bold-total': isTotal(data)}">
                                            {{ utils.formatDecimal(data.netYearlyAverageTimeOnDemurrage, 1) }}
                                            </span>
                                        </template>
                                    </Column>

                                    <Column
                                        :header="year + ' ' + $t('DemurrageStatistics.netYearlyAverageTimeOnDemurrage')"
                                        v-for="year in previousYearsColumnShow"
                                        :key="'netYearlyAverageTimeOnDemurrage' + year" style="width: 150px;">
                                        <template #body="{ data }">
                                            <span :class="{'bold-total': isTotal(data.lastYears[year])}">
                                            {{
                                                utils.formatDecimal(data.lastYears[year]?.netYearlyAverageTimeOnDemurrage,
                                            1) }}
                                            </span>
                                        </template>
                                    </Column>

                                    <Column :header="$t('DemurrageStatistics.grossQuantity')" style="width: 150px;">
                                        <template #body="{ data }">
                                            <span :class="{'bold-total': isTotal(data)}">
                                            {{ data.grossQuantity ? utils.formatInteger(Math.round(data.grossQuantity))
                                                : '' }}
                                                </span>
                                        </template>
                                    </Column>
                                    <Column :header="$t('DemurrageStatistics.grossMonthlyDemurrageRatioTotalTon')"
                                        style="width: 150px;">
                                        <template #body="{ data }">
                                            <span :class="{'bold-total': isTotal(data)}">
                                            {{ utils.formatDecimal(data.grossMonthlyDemurrageRatioTotalTon, 2) }}
                                            </span>
                                        </template>
                                    </Column>

                                    <Column
                                        :header="year + ' ' + $t('DemurrageStatistics.grossMonthlyDemurrageRatioTotalTon')"
                                        v-for="year in previousYearsColumnShow"
                                        :key="'grossMonthlyDemurrageRatioTotalTon' + year" style="width: 150px;">
                                        <template #body="{ data }">
                                            <span :class="{'bold-total': isTotal(data.lastYears[year])}">
                                            {{
                                                utils.formatDecimal(data.lastYears[year]?.grossMonthlyDemurrageRatioTotalTon,
                                            2) }}
                                            </span>
                                        </template>
                                    </Column>

                                    <Column :header="$t('DemurrageStatistics.grossYearlyDemurrageRatioTotalTon')"
                                        style="width: 150px;">
                                        <template #body="{ data }">
                                            <span :class="{'bold-total': isTotal(data)}">
                                            {{ utils.formatDecimal(data.grossYearlyDemurrageRatioTotalTon, 2) }}
                                            </span>
                                        </template>
                                    </Column>

                                    <Column
                                        :header="year + ' ' + $t('DemurrageStatistics.grossYearlyDemurrageRatioTotalTon')"
                                        v-for="year in previousYearsColumnShow"
                                        :key="'grossYearlyDemurrageRatioTotalTon' + year" style="width: 150px;">
                                        <template #body="{ data }">
                                            <span :class="{'bold-total': isTotal(data.lastYears[year])}">
                                            {{
                                                utils.formatDecimal(data.lastYears[year]?.grossYearlyDemurrageRatioTotalTon,
                                            2) }}
                                            </span>
                                        </template>
                                    </Column>

                                    <Column :header="$t('DemurrageStatistics.netQuantity')" style="width: 150px;">
                                        <template #body="{ data }">
                                            <span :class="{'bold-total': isTotal(data)}">
                                            {{ data.netQuantity ? utils.formatInteger(Math.round(data.netQuantity)) : ''
                                            }}
                                            </span>
                                        </template>
                                    </Column>
                                    <Column :header="$t('DemurrageStatistics.netMonthlyDemurrageRatioTotalTon')"
                                        style="width: 150px;">
                                        <template #body="{ data }">
                                            <span :class="{'bold-total': isTotal(data)}">
                                            {{ utils.formatDecimal(data.netMonthlyDemurrageRatioTotalTon, 2) }}
                                            </span>
                                        </template>
                                    </Column>

                                    <Column
                                        :header="year + ' ' + $t('DemurrageStatistics.netMonthlyDemurrageRatioTotalTon')"
                                        v-for="year in previousYearsColumnShow"
                                        :key="'netMonthlyDemurrageRatioTotalTon' + year" style="width: 150px;">
                                        <template #body="{ data }">
                                            <span :class="{'bold-total': isTotal(data.lastYears[year])}">
                                            {{
                                                utils.formatDecimal(data.lastYears[year]?.netMonthlyDemurrageRatioTotalTon,
                                            2) }}
                                            </span>
                                        </template>
                                    </Column>

                                    <Column :header="$t('DemurrageStatistics.netYearlyDemurrageRatioTotalTon')"
                                        style="width: 150px;">
                                        <template #body="{ data }">
                                            <span :class="{'bold-total': isTotal(data)}">
                                            {{ utils.formatDecimal(data.netYearlyDemurrageRatioTotalTon, 2) }}
                                            </span>
                                        </template>
                                    </Column>

                                    <Column
                                        :header="year + ' ' + $t('DemurrageStatistics.netYearlyDemurrageRatioTotalTon')"
                                        v-for="year in previousYearsColumnShow"
                                        :key="'netYearlyDemurrageRatioTotalTon' + year" style="width: 150px;">
                                        <template #body="{ data }">
                                            <span :class="{'bold-total': isTotal(data.lastYears[year])}">
                                            {{
                                                utils.formatDecimal(data.lastYears[year]?.netYearlyDemurrageRatioTotalTon,
                                            2) }}
                                            </span>
                                        </template>
                                    </Column>

                                    <Column :header="$t('DemurrageStatistics.grossTimeOnDemurrage')"
                                        style="width: 150px;">
                                        <template #body="{ data }">
                                            <span :class="{'bold-total': isTotal(data)}">
                                            {{ data.grossTimeOnDemurrage ?
                                                utils.formatInteger(Math.round(data.grossTimeOnDemurrage)) : '' }}
                                                </span>
                                        </template>
                                    </Column>
                                    <Column :header="$t('DemurrageStatistics.grossMonthlyDemurrageRatioHrsTon')"
                                        style="width: 150px;">
                                        <template #body="{ data }">
                                            <span :class="{'bold-total': isTotal(data)}">
                                            {{ utils.formatDecimal(data.grossMonthlyDemurrageRatioHrsTon, 2) }}
                                            </span>
                                        </template>
                                    </Column>

                                    <Column
                                        :header="year + ' ' + $t('DemurrageStatistics.grossMonthlyDemurrageRatioHrsTon')"
                                        v-for="year in previousYearsColumnShow"
                                        :key="'grossMonthlyDemurrageRatioHrsTon' + year" style="width: 150px;">
                                        <template #body="{ data }">
                                            <span :class="{'bold-total': isTotal(data.lastYears[year])}">
                                            {{
                                                utils.formatDecimal(data.lastYears[year]?.grossMonthlyDemurrageRatioHrsTon,
                                            2) }}
                                            </span>
                                        </template>
                                    </Column>
                                    <Column :header="$t('DemurrageStatistics.grossYearlyDemurrageRatioHrsTon')"
                                        style="width: 150px;">
                                        <template #body="{ data }">
                                            <span :class="{'bold-total': isTotal(data)}">
                                            {{ utils.formatDecimal(data.grossYearlyDemurrageRatioHrsTon, 2) }}
                                            </span>
                                        </template>
                                    </Column>

                                    <Column
                                        :header="year + ' ' + $t('DemurrageStatistics.grossYearlyDemurrageRatioHrsTon')"
                                        v-for="year in previousYearsColumnShow"
                                        :key="'grossYearlyDemurrageRatioHrsTon' + year" style="width: 150px;">
                                        <template #body="{ data }">
                                            <span :class="{'bold-total': isTotal(data.lastYears[year])}">
                                            {{
                                                utils.formatDecimal(data.lastYears[year]?.grossYearlyDemurrageRatioHrsTon,
                                            2) }}
                                            </span>
                                        </template>
                                    </Column>
                                    <Column :header="$t('DemurrageStatistics.netTimeOnDemurrage')"
                                        style="width: 150px;">
                                        <template #body="{ data }">
                                            <span :class="{'bold-total': isTotal(data)}">
                                            {{ data.netTimeOnDemurrage ?
                                                utils.formatInteger(Math.round(data.netTimeOnDemurrage)) : '' }}
                                                </span>
                                        </template>
                                    </Column>
                                    <Column :header="$t('DemurrageStatistics.netMonthlyDemurrageRatioHrsTon')"
                                        style="width: 150px;">
                                        <template #body="{ data }">
                                            <span :class="{'bold-total': isTotal(data)}">
                                            {{ utils.formatDecimal(data.netMonthlyDemurrageRatioHrsTon, 2) }}
                                            </span>
                                        </template>
                                    </Column>

                                    <Column
                                        :header="year + ' ' + $t('DemurrageStatistics.netMonthlyDemurrageRatioHrsTon')"
                                        v-for="year in previousYearsColumnShow"
                                        :key="'netMonthlyDemurrageRatioHrsTon' + year" style="width: 150px;">
                                        <template #body="{ data }">
                                            <span :class="{'bold-total': isTotal(data.lastYears[year])}">
                                            {{ utils.formatDecimal(data.lastYears[year]?.netMonthlyDemurrageRatioHrsTon,
                                            2) }}
                                            </span>
                                        </template>
                                    </Column>
                                    <Column :header="$t('DemurrageStatistics.netYearlyDemurrageRatioHrsTon')"
                                        style="width: 150px;">
                                        <template #body="{ data }">
                                            <span :class="{'bold-total': isTotal(data)}">
                                            {{ utils.formatDecimal(data.netYearlyDemurrageRatioHrsTon, 2) }}
                                            </span>
                                        </template>
                                    </Column>

                                    <Column
                                        :header="year + ' ' + $t('DemurrageStatistics.netYearlyDemurrageRatioHrsTon')"
                                        v-for="year in previousYearsColumnShow"
                                        :key="'netYearlyDemurrageRatioHrsTon' + year" style="width: 150px;">
                                        <template #body="{ data }">
                                            <span :class="{'bold-total': isTotal(data.lastYears[year])}">
                                            {{ utils.formatDecimal(data.lastYears[year]?.netYearlyDemurrageRatioHrsTon,
                                            2) }}
                                            </span>
                                        </template>
                                    </Column>

                                    <template #empty>
                                        {{ $t('noRecordsFound') }}
                                    </template>
                                </DataTable>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel :header="$t('DemurrageStatistics.plant')">
                        <div class="grid">
                            <div class="col-12">
                                <DataTable :value="plantData" showGridlines stripedRows :reorderableColumns="false" :loading="plantLoading">

                                    <Column field="referenceDate" :header="$t('DemurrageStatistics.referenceDate')"
                                        dataType="date" style="width: 150px;">
                                        <template #body="element">
                                            {{ element.data.referenceDate != null ?
                                                $t('monthNames.' + new Date(element.data.referenceDate).getMonth())

                                                :
                                                null }}
                                        </template>
                                    </Column>

                                    <Column :header="$t('DemurrageStatistics.southTotalDemurrage')"
                                        style="width: 150px;">
                                        <template #body="{ data }">
                                            {{ data.southTotalDemurrage ? '$ ' +
                                                utils.formatInteger(Math.round(data.southTotalDemurrage)) : '' }}
                                        </template>
                                    </Column>
                                    <Column :header="$t('DemurrageStatistics.southTotalDemurragePercent')"
                                        style="width: 150px;">
                                        <template #body="{ data }">
                                            {{ data.southTotalDemurragePercent ?
                                                utils.formatInteger(Math.round(data.southTotalDemurragePercent)) + ' %' : ''
                                            }}
                                        </template>
                                    </Column>
                                    <Column :header="$t('DemurrageStatistics.northTotalDemurrage')"
                                        style="width: 150px;">
                                        <template #body="{ data }">
                                            {{ data.northTotalDemurrage ? '$ ' +
                                                utils.formatInteger(Math.round(data.northTotalDemurrage)) : '' }}
                                        </template>
                                    </Column>
                                    <Column :header="$t('DemurrageStatistics.northTotalDemurragePercent')"
                                        style="width: 150px;">
                                        <template #body="{ data }">
                                            {{ data.northTotalDemurragePercent ?
                                                utils.formatInteger(Math.round(data.northTotalDemurragePercent)) + ' %' : ''
                                            }}
                                        </template>
                                    </Column>
                                    <Column :header="$t('DemurrageStatistics.total')" style="width: 150px;">
                                        <template #body="{ data }">
                                            {{ data.totalDemurrage ? '$ ' +
                                                utils.formatInteger(Math.round(data.totalDemurrage)) : '' }}
                                        </template>
                                    </Column>
                                    <template #empty>
                                        {{ $t('noRecordsFound') }}
                                    </template>
                                    <ColumnGroup type="footer">
                                        <Row>
                                            <Column />
                                            <Column footerClass="bold-total"
                                                :footer="plantTotal('southTotalDemurrage') ? '$ ' + utils.formatInteger(Math.round(plantTotal('southTotalDemurrage'))) : ''" />
                                            <Column :footer="utils.formatInteger(Math.round(plantTotalPercent('SOUTH'))) + ' %'"/>
                                            <Column
                                                :footer="plantTotal('northTotalDemurrage') ? '$ ' + utils.formatInteger(Math.round(plantTotal('northTotalDemurrage'))) : ''" />
                                                <Column :footer="utils.formatInteger(Math.round(plantTotalPercent('NORTH'))) + ' %'"/>
                                            <Column
                                                :footer="plantTotal('totalDemurrage') ? '$ ' + utils.formatInteger(Math.round(plantTotal('totalDemurrage'))) : ''" />
                                        </Row>
                                    </ColumnGroup>
                                </DataTable>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel :header="$t('DemurrageStatistics.chargeDischarge')">
                        <div class="grid">
                            <div class="col-12">
                                <DataTable :value="chargeDischargeData" showGridlines stripedRows :reorderableColumns="false" :loading="chargeDischargeLoading">
                                    <Column field="referenceDate" :header="$t('DemurrageStatistics.referenceDate')"
                                        dataType="date" style="width: 150px;">
                                        <template #body="element">
                                            {{ element.data.referenceDate != null ?
                                                $t('monthNames.' + new Date(element.data.referenceDate).getMonth())
                                                :
                                                null }}
                                        </template>
                                    </Column>

                                    <Column :header="$t('DemurrageStatistics.chargeTotalDemurrage')"
                                        style="width: 150px;">
                                        <template #body="{ data }">
                                            {{ data.chargeTotalDemurrage ? '$ ' +
                                                utils.formatInteger(Math.round(data.chargeTotalDemurrage)) : '' }}
                                        </template>
                                    </Column>
                                    <Column :header="$t('DemurrageStatistics.chargeTotalDemurragePercent')"
                                        style="width: 150px;">
                                        <template #body="{ data }">
                                            {{ data.chargeTotalDemurragePercent ?
                                                utils.formatInteger(Math.round(data.chargeTotalDemurragePercent)) + ' %' :
                                                '' }}
                                        </template>
                                    </Column>
                                    <Column :header="$t('DemurrageStatistics.dischargeTotalDemurrage')"
                                        style="width: 150px;">
                                        <template #body="{ data }">
                                            {{ data.dischargeTotalDemurrage ? '$ ' +
                                                utils.formatInteger(Math.round(data.dischargeTotalDemurrage)) : '' }}
                                        </template>
                                    </Column>
                                    <Column :header="$t('DemurrageStatistics.dischargeTotalDemurragePercent')"
                                        style="width: 150px;">
                                        <template #body="{ data }">
                                            {{ data.dischargeTotalDemurragePercent ?
                                                utils.formatInteger(Math.round(data.dischargeTotalDemurragePercent)) + ' %'
                                                : '' }}
                                        </template>
                                    </Column>
                                    <Column :header="$t('DemurrageStatistics.total')" style="width: 150px;">
                                        <template #body="{ data }">
                                            {{ data.totalDemurrage ? '$ ' +
                                                utils.formatInteger(Math.round(data.totalDemurrage)) : '' }}
                                        </template>
                                    </Column>
                                    <template #empty>
                                        {{ $t('noRecordsFound') }}
                                    </template>
                                    <ColumnGroup type="footer">
                                        <Row>
                                            <Column />
                                            <Column
                                                :footer="chargeDischargeTotal('chargeTotalDemurrage') ? '$ ' + utils.formatInteger(Math.round(chargeDischargeTotal('chargeTotalDemurrage'))) : ''" />
                                            <Column :footer="utils.formatInteger(Math.round(chargeDischargeTotalPercent('CHARGE'))) + ' %'"/>
                                            <Column
                                                :footer="chargeDischargeTotal('dischargeTotalDemurrage') ? '$ ' + utils.formatInteger(Math.round(chargeDischargeTotal('dischargeTotalDemurrage'))) : ''" />
                                            <Column :footer="utils.formatInteger(Math.round(chargeDischargeTotalPercent('DISCHARGE'))) + ' %'"/>
                                            <Column
                                                :footer="chargeDischargeTotal('totalDemurrage') ? '$ ' + utils.formatInteger(Math.round(chargeDischargeTotal('totalDemurrage'))) : ''" />
                                            
                                        </Row>
                                    </ColumnGroup>
                                </DataTable>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel :header="$t('DemurrageStatistics.graphs')">
                        <div class="grid">
                            <DemurrageStatisticsGraph v-for="graph in graphs" :key="graph.id" class="my-2"
                                :input="recapData" :x="graph.label" :labelType="graph.labelType"
                                :columns="graph.details" :editable="graph.deletable" :allColumns="recapColumns"
                                :title="graph.title" :id="graph.id" :order="graph.graphOrder" :lastYears="lastYears"
                                @onSaveSuccess="loadGraphs" />
                        </div>

                        <div class="grid">
                            <div class="col-12">
                                <Button :icon="'pi pi-plus'" rounded outlined @click="addNewGraph"
                                    :label="$t('btn.add')" class="m-1" />
                            </div>
                            <DemurrageStatisticsGraph class="my-2" v-for="(n, index) in newGraphs" :key="index"
                                :input="recapData" :x="'referenceDate'" :labelType="'month'" :columns="[]"
                                :editable="true" :allColumns="recapColumns" :title="''" :id="0" :order="0"
                                :lastYears="lastYears" @onSaveSuccess="loadGraphs" />
                        </div>
                    </TabPanel>
                    <TabPanel :header="$t('DemurrageStatistics.progressive')">
                        <div class="grid">
                            <div class="col-12">
                                <DataTable :value="progressiveData" showGridlines stripedRows :reorderableColumns="false" :loading="progressiveDataLoading">

                                    <Column field="referenceDate" :header="$t('DemurrageStatistics.referenceDate')"
                                        dataType="date" style="width: 150px;">
                                        <template #body="element">
                                            {{ element.data.referenceDate != null ?
                                                $t('monthNames.' + new Date(element.data.referenceDate).getMonth())

                                                :
                                                null }}
                                        </template>
                                    </Column>

                                    <Column :header="$t('DemurrageStatistics.plantSouthNorth')" style="width: 100px;">
                                        <template #body="{ data }">
                                            {{ data.registryPlant }}
                                        </template>
                                    </Column>
                                    <Column :header="$t('DemurrageStatistics.dischargeLifting')" style="width: 100px;">
                                        <template #body="{ data }">
                                            {{ data.loadingUnloading }}
                                        </template>
                                    </Column>
                                    <Column :header="$t('DemurrageStatistics.vesselName')" style="width: 150px;">
                                        <template #body="{ data }">
                                            {{ data.registryVessel }}
                                        </template>
                                    </Column>
                                    <Column :header="$t('DemurrageStatistics.allocation')" style="width: 150px;">
                                        <template #body="{ data }">
                                            {{ data.voyageNumber }}
                                        </template>
                                    </Column>
                                    <Column :header="$t('DemurrageStatistics.product')" style="width: 150px;">
                                        <template #body="{ data }">
                                            {{ data.product }}
                                        </template>
                                    </Column>
                                    <Column :header="$t('DemurrageStatistics.demurrageRate')" style="width: 150px;">
                                        <template #body="{ data }">
                                            {{ data.demurrageRate ? '$ ' +
                                                utils.formatInteger(Math.round(data.demurrageRate)) : '' }}
                                        </template>
                                    </Column>
                                    <Column :header="$t('DemurrageStatistics.timeOnDemurrage')" style="width: 150px;">
                                        <template #body="{ data }">
                                            {{ data.timeOnDemurrageMinutes != 0 ?
                                                utils.formatDecimal(data.timeOnDemurrageMinutes / 60, 2) : 0 }}
                                        </template>
                                    </Column>
                                    <Column :header="$t('DemurrageStatistics.totalDemurrage')" style="width: 150px;">
                                        <template #body="{ data }">
                                            {{ data.totalDemurrage != null ? '$ ' +
                                                utils.formatInteger(data.totalDemurrage) : '' }}
                                        </template>
                                    </Column>
                                    <Column :header="$t('DemurrageStatistics.note')" style="width: 150px;">
                                        <template #body="{ data }">
                                            {{ data.reasonDescription }}
                                        </template>
                                    </Column>
                                    <Column :header="$t('DemurrageStatistics.netOfTimeEXpired')" style="width: 150px;">
                                        <template #body="{ data }">
                                            {{ data.totalDemurrageString ? data.totalDemurrageString : '$ ' +
                                                utils.formatInteger(data.totalDemurrageNet ? data.totalDemurrageNet : 0) }}
                                        </template>
                                    </Column>
                                    <Column :header="$t('DemurrageStatistics.note')" style="width: 250px;">
                                        <template #body="{ data }">
                                            {{ data.extendedReasonDescription }}
                                        </template>
                                    </Column>

                                    <Column :header="$t('DemurrageStatistics.planningStrategy')" style="width: 100px;">
                                        <template #body="{ data }">
                                            {{ data.planningStrategy ? $t('yes') : $t('no') }}
                                        </template>
                                    </Column>
                                    <template #empty>
                                        {{ $t('noRecordsFound') }}
                                    </template>
                                </DataTable>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel :header="$t('DemurrageStatistics.pivot')">
                        <div class="grid">
                            <div class="col-12 ">
                                <div class="grid">
                                    <div class="col-12 lg:col-3 field">
                                        <label>{{ $t('DemurrageStatistics.month') }}</label>
                                        <!-- <Calendar :class="{ 'p-inputtext-sm w-full': true }" placeholder="mm/yyyy"
                                            view="month" v-model="pivotFilters.month" @update:modelValue="loadPivot()"
                                            dateFormat="mm/yy" :showTime="false" :showIcon="true" :showButtonBar="true"
                                            :yearNavigator="true" /> -->
                                        <MultiSelect v-model="pivotFilters.month" :options="pivotMonths"
                                            optionLabel="name" optionValue="value" class="w-full p-inputtext-sm"
                                            @change="loadPivot()" />
                                    </div>
                                    <div class="col-12 lg:col-3 field">
                                        <label for="products">{{ $t('product.fk') }}</label>
                                        <GenericCustomMultiSelect v-model="pivotFilters.product" filter
                                            :maxSelectedLabels="5" api="masterdata/product-combo"
                                            name="masterdata-product-combo"
                                            :format="{ label: 'label', value: 'extraData.code' }"
                                            class="w-full p-inputtext-sm" @change="loadPivot()" />
                                    </div>
                                    <div class="col-12 lg:col-3 field">
                                        <label for="plant">{{ $t('DemurrageStatistics.plant') }} </label>
                                        <MultiSelect v-model="pivotFilters.plant" :options="[
                                            { label: 'ISAB SUD', value: 'S' },
                                            { label: 'ISAB NORD', value: 'N' }
                                        ]" optionLabel="label" optionValue="value" @change="loadPivot()"
                                            :maxSelectedLabels="2" :format="{ label: 'label', value: 'value' }"
                                            class="w-full p-inputtext-sm" />
                                    </div>
                                    <div class="col-12 lg:col-3 field">
                                        <label for="chargeDischarge">{{ $t('DemurrageStatistics.dischargeLifting')
                                            }}</label>
                                        <MultiSelect v-model="pivotFilters.chargeDischarge"
                                            :format="{ label: 'label', value: 'value' }" :options="[
                                                { value: 'D', label: $t('DemurrageStatistics.discharge') },
                                                { value: 'L', label: $t('DemurrageStatistics.lifting') },
                                            ]" :maxSelectedLabels="2" optionLabel="label" optionValue="value"
                                            @change="loadPivot()" class="w-full p-inputtext-sm" />
                                    </div>
                                </div>
                            </div>

                            <div class="col-12">
                                <DataTable :value="pivotGridData" showGridlines stripedRows :reorderableColumns="false"
                                    :loading="pivotLoading" scrollable :responsiveLayout="'stack'" scrollHeight="flex">
                                    <Column field="key" :header="$t('DemurrageStatistics.mainReason')"
                                        style="width: 150px;" />

                                    <Column :header="$t('DemurrageStatistics.totalDemurrage')" style="width: 150px;">
                                        <template #body="{ data }">
                                            {{ data.totalDemurrage ? '$ ' +
                                                utils.formatInteger(Math.round(data.totalDemurrage)) : '' }}
                                        </template>
                                    </Column>
                                    <Column :header="$t('DemurrageStatistics.totalDemurragePercent')"
                                        style="width: 150px;">
                                        <template #body="{ data }">
                                            {{ data.totalDemurragePercent ?
                                                utils.formatInteger(Math.round(data.totalDemurragePercent)) + ' %' : '' }}
                                        </template>
                                    </Column>
                                    <Column :header="$t('DemurrageStatistics.timeOnDemurrage')" style="width: 150px;">
                                        <template #body="{ data }">
                                            {{ data.timeOnDemurrage ?
                                                utils.formatInteger(Math.round(data.timeOnDemurrage)) : '' }}
                                        </template>
                                    </Column>
                                    <Column :header="$t('DemurrageStatistics.timeOnDemurragePercent')"
                                        style="width: 150px;">
                                        <template #body="{ data }">
                                            {{ utils.formatDecimal(data.timeOnDemurragePercent, 1) }} %
                                        </template>
                                    </Column>
                                    <Column :header="$t('DemurrageStatistics.averageTimeOnDemurrage')"
                                        style="width: 150px;">
                                        <template #body="{ data }">
                                            {{ data.averageTimeOnDemurrage ?
                                                utils.formatInteger(Math.round(data.averageTimeOnDemurrage)) : '' }}
                                        </template>
                                    </Column>
                                    <Column :header="$t('DemurrageStatistics.averageDemurrageRate')"
                                        style="width: 150px;">
                                        <template #body="{ data }">
                                            {{ data.averageDemurrageRate ? '$ ' +
                                                utils.formatInteger(Math.round(data.averageDemurrageRate)) : '' }}
                                        </template>
                                    </Column>
                                    <template #empty>
                                        {{ $t('noRecordsFound') }}
                                    </template>
                                </DataTable>

                            </div>
                            <div class="col-6">
                                <DemurragePivotGraph :input="pivotGridDataFiltered" />
                            </div>
                        </div>

                    </TabPanel>
                    <TabPanel :header="$t('DemurrageStatistics.actVsBdg')">
                        <div class="grid">
                            <div class="col-12 ">
                                <DataTable :value="actVsBudgetData" showGridlines stripedRows
                                    :reorderableColumns="false" v-model:editingRows="editingRowsActVsBudget"
                                    dataKey="referenceDate" editMode="row" @row-edit-save="onRowEditActVsBudgetSave"
                                    :loading="actVsBudgetLoading" scrollable :responsiveLayout="'stack'"
                                    scrollHeight="flex">
                                    <Column :rowEditor="true">
                                    </Column>
                                    <Column field="key" :header="$t('DemurrageStatistics.referenceDate')"
                                        style="width: 150px;">
                                        <template #body="element">
                                            {{ element.data.referenceDate != null ?
                                                $t('monthNames.' + new Date(element.data.referenceDate).getMonth())

                                                :
                                                null }}
                                        </template>
                                    </Column>
                                    <Column :header="$t('DemurrageStatistics.grossTotalDemurrage')"
                                        style="width: 150px;">
                                        <template #body="{ data }">
                                            {{ data.totalDemurrageGross ? '$ ' +
                                                utils.formatInteger(Math.round(data.totalDemurrageGross)) : '' }}
                                        </template>
                                    </Column>
                                    <!-- <Column :header="$t('DemurrageStatistics.netTotalDemurrage')" style="width: 150px;">
                                        <template #body="{ data }">
                                            {{ data.totalDemurrageNet ? '$ ' +
                                                utils.formatInteger(Math.round(data.totalDemurrageNet)) : '' }}
                                        </template>
                                    </Column> -->
                                    <Column :header="$t('DemurrageStatistics.budget')" field="budget"
                                        style="width: 150px;">
                                        <template #editor="{ data, field }">
                                            <InputNumber v-model="data[field]" inputId="currency-us" mode="currency"
                                                currency="USD" locale="en-US" />
                                        </template>
                                        <template #body="{ data }">
                                            {{ data.budget ? '$ ' + utils.formatInteger(data.budget) : '' }}
                                        </template>
                                    </Column>
                                    <Column :header="$t('DemurrageStatistics.estimatedVsBudget')" style="width: 150px;">
                                        <template #body="{ data }">
                                            {{ data.estimatedVsBudget ? '$ ' +
                                                utils.formatInteger(Math.round(data.estimatedVsBudget)) : '' }}
                                        </template>
                                    </Column>
                                    <Column :header="'Previous Year Gross Demurrage'"
                                        style="width: 150px;">
                                        <template #body="{ data }">
                                            {{ data.previousYearGrossDemurrage ? '$ ' +
                                                utils.formatInteger(Math.round(data.previousYearGrossDemurrage)) : '' }}
                                        </template>
                                    </Column>
                                    <Column :header="'Gross Demurrage - Actual previous year'" style="width: 150px;">
                                        <template #body="{ data }">
                                            {{ data.previousYearDelta ? '$ ' +
                                                utils.formatInteger(Math.round(data.previousYearDelta)) : '' }}
                                        </template>
                                    </Column>
                                    <template #empty>
                                        {{ $t('noRecordsFound') }}
                                    </template>

                                    <ColumnGroup type="footer">
                                        <Row>
                                            <Column colspan="2" />
                                            <Column
                                                :footer="actVsBudgeTotal('totalDemurrageGross') ? '$ ' + utils.formatInteger(Math.round(actVsBudgeTotal('totalDemurrageGross'))) : ''" />
                                            <!-- <Column
                                                :footer="actVsBudgeTotal('totalDemurrageNet') ? '$ ' + utils.formatInteger(Math.round(actVsBudgeTotal('totalDemurrageNet'))) : ''" /> -->
                                            <Column
                                                :footer="actVsBudgeTotal('budget') ? '$ ' + utils.formatInteger(Math.round(actVsBudgeTotal('budget'))) : ''" />
                                            <Column
                                                :footer="actVsBudgeTotal('estimatedVsBudget') ? '$ ' + utils.formatInteger(Math.round(actVsBudgeTotal('estimatedVsBudget'))) : ''" />
                                                <Column
                                                :footer="actVsBudgeTotal('previousYearGrossDemurrage') ? '$ ' + utils.formatInteger(Math.round(actVsBudgeTotal('previousYearGrossDemurrage'))) : ''" />
                                            <Column
                                                :footer="actVsBudgeTotal('previousYearDelta') ? '$ ' + utils.formatInteger(Math.round(actVsBudgeTotal('previousYearDelta'))) : ''" />
                                        </Row>
                                    </ColumnGroup>
                                </DataTable>
                            </div>
                            <div class="col-12" v-if="actVsBudgetData.length != 0">
                                <DemurrageStatisticsGraph :key="1" class="my-2" :input="actVsBudgetData"
                                    :disableLastYears="true" x="referenceDate" labelType="month"
                                    :columns="actVsBudgetColumns"
                                    :title="$t('DemurrageStatistics.titleActVsBudgetGraph')" :id="1" />

                            </div>
                        </div>
                    </TabPanel>
                </TabView>
            </div>
        </div>
    </main>
</template>

<style scoped>
.bold-total {
    font-weight: bold;
}
</style>
